export default "__VITE_ASSET__DBIhQ4uL__"